<template>
	<div>
		<v-dialog :key="dialogKey" v-model="showDialog" persistent scrollable :max-width="$vuetify.breakpoint.mobile ? '75%' : '50%'">
			<v-card class="justify-center text-center card-rounded pb-5" min-height="90vh">
				<v-card-title
					class="pa-2 white--text justify-center text-center secondary"
					style="font-family: Montserrat; font-style: normal; font-weight: bold; font-size: 12px; line-height: 7px; text-align: center"
				>
					<v-row>
						<v-spacer></v-spacer>
						<span class="headline white--text">Edit Offer</span>
						<v-spacer></v-spacer>
					</v-row>
					<v-btn icon color="white" @click="close">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>

				<v-card-text class="text-center justify-center">
					<v-container class="card-rounded pb-2 text-center justify-center">
						<v-form>
							<div>
								<v-row>
									<v-col class="justify-center text-center">
										<v-btn-toggle v-model="calendarInputMode" mandatory>
											<v-btn
												rounded
												small
												:color="calendarInputMode == 0 ? 'primary' : '#FFF'"
												:class="[calendarInputMode == 0 ? 'white--text' : 'primary--text text--darken-2']"
												style="
													border-radius: 20px 0px 0px 20px;
													font-family: Montserrat;
													font-style: normal;
													font-weight: bold;
													font-size: 14px;
													line-height: 17px;
													text-align: center;
												"
												@click="calculateRequestDates(0)"
											>
												Date range
											</v-btn>

											<v-btn
												rounded
												small
												:color="calendarInputMode == 1 ? 'primary' : '#FFF'"
												:class="[calendarInputMode == 1 ? 'white--text' : 'primary--text text--darken-2']"
												style="
													border-radius: 0px 20px 20px 0px;
													font-family: Montserrat;
													font-style: normal;
													font-weight: bold;
													font-size: 14px;
													line-height: 17px;
													text-align: center;
												"
												@click="calculateRequestDates(1)"
											>
												Specific days
											</v-btn>
										</v-btn-toggle>
									</v-col>
								</v-row>
								<v-date-picker
									v-model="selectedDates"
									:min="new Date().toISOString().substr(0, 10)"
									header-color="primary"
									color="primary"
									full-width
									no-title
									:multiple="calendarInputMode == 1"
									:range="calendarInputMode == 0"
									class="elevation-0"
								></v-date-picker>

								<v-row>
									<v-col>
										<v-dialog
											ref="startDatedialog"
											v-model="startDateModal"
											:value="computedStartDateFormatted"
											clearable
											:return-value.sync="startDate"
											persistent
											width="290px"
										>
											<template #activator="{ on }">
												<span class="font-weight-bold">Start Date:</span>
												<v-text-field v-model="startDate" :rules="[rules.startDate]" filled dense readonly v-on="on"></v-text-field>
											</template>
											<v-date-picker v-model="startDate" :allowed-dates="allowedStartDates" header-color="primary" color="primary" :min="minDate" scrollable>
												<v-spacer></v-spacer>
												<v-btn text color="primary" @click="startDateModal = false">Cancel</v-btn>
												<v-btn
													text
													color="primary"
													@click="
														$refs.startDatedialog.save(startDate);
														if (calendarInputMode === 0) calculateRequestDates();
													"
													>OK</v-btn
												>
											</v-date-picker>
										</v-dialog>
									</v-col>

									<v-col>
										<v-dialog ref="endDateDialog" v-model="endDateModal" :return-value.sync="endDate" persistent width="290px">
											<template #activator="{ on }">
												<span class="font-weight-bold">End Date:</span>
												<v-text-field
													v-model="endDate"
													:value="computedEndDateFormatted"
													clearable
													:rules="[rules.endDate]"
													filled
													dense
													readonly
													v-on="on"
												></v-text-field>
											</template>
											<v-date-picker v-model="endDate" header-color="primary" color="primary" :min="minDate" scrollable>
												<v-spacer></v-spacer>
												<v-btn text color="primary" @click="endDateModal = false">Cancel</v-btn>
												<v-btn
													text
													color="primary"
													@click="
														$refs.endDateDialog.save(endDate);
														if (calendarInputMode === 0) calculateRequestDates();
													"
													>OK</v-btn
												>
											</v-date-picker>
										</v-dialog>
									</v-col>
								</v-row>

								<p class="font-weight-bold black--text mb-0 mt-0">Time</p>
								<v-row>
									<v-col>
										<v-dialog ref="startTimeDialog" v-model="startTimeModal" :return-value.sync="startTime" persistent width="290px">
											<template #activator="{ on }">
												<span class="font-weight-bold">Start Time:</span>
												<v-text-field v-model="startTime" placeholder="Start Time:" readonly filled dense v-on="on"></v-text-field>
											</template>
											<v-time-picker v-if="startTimeModal" v-model="startTime" full-width format="24hr" :allowed-minutes="[0, 15, 30, 45]">
												<v-spacer></v-spacer>
												<v-btn text color="primary" @click="startTimeModal = false">Cancel</v-btn>
												<v-btn
													text
													color="primary"
													@click="
														$refs.startTimeDialog.save(startTime);
														updateRequestDateTimes(startTime, '');
													"
													>OK</v-btn
												>
											</v-time-picker>
										</v-dialog>
									</v-col>

									<v-col>
										<v-dialog ref="endTimedialog" v-model="endTimeModal" :return-value.sync="endTime" persistent width="290px">
											<template #activator="{ on }">
												<span class="font-weight-bold">End Time:</span>
												<v-text-field v-model="endTime" placeholder="End Time:" readonly filled dense v-on="on"></v-text-field>
											</template>
											<v-time-picker v-if="endTimeModal" v-model="endTime" full-width format="24hr" :allowed-minutes="[0, 15, 30, 45]">
												<v-spacer></v-spacer>
												<v-btn text color="primary" @click="endTimeModal = false">Cancel</v-btn>
												<v-btn
													text
													color="primary"
													@click="
														$refs.endTimedialog.save(endTime);
														updateRequestDateTimes('', endTime);
													"
													>OK</v-btn
												>
											</v-time-picker>
										</v-dialog>
									</v-col>
								</v-row>

								<p v-if="startDate !== null && endDate !== null && endDate !== ''" class="font-weight-bold black--text mb-0 mt-0">Change times per day</p>
								<v-row v-if="startDate !== null && endDate !== null && endDate !== ''" class="text-center justify-center">
									<v-col>
										<div style="display: flex; overflow: auto">
											<v-card
												v-for="date in request_dates"
												:key="date.date"
												outlined
												elevation="1"
												class="ml-1 mr-1 mt-2 mb-2 pl-1 pr-1"
												style="border-radius: 8px; !important"
												@click="onClickDateIcon(date)"
											>
												<v-row no-gutters>
													<v-col cols="12">
														<calendar-date-icon
															:color="'primary'"
															:date="date.date"
															:start_time="getLocumDayTime(date.date, 'start_time')"
															:end_time="getLocumDayTime(date.date, 'end_time')"
															small
															class="ml-1 mr-1 mt-2 mb-0 justify-center text-center"
															@click="onClickDateIcon(date)"
														>
														</calendar-date-icon>
													</v-col>
												</v-row>
											</v-card>
										</div>
									</v-col>
									<v-col>
										<v-dialog v-model="showEditRequestTimeDialog" persistent scrollable width="290px" :max-width="$vuetify.breakpoint.mobile ? '80%' : '25%'">
											<v-card class="justify-center text-center card-rounded pb-5" min-height="40vh">
												<v-card-title
													class="pa-2 white--text justify-center text-center primary"
													style="font-family: Montserrat; font-style: normal; font-weight: bold; font-size: 12px; line-height: 7px; text-align: center"
												>
													<v-row>
														<v-spacer></v-spacer>
														<span class="headline white--text">{{ EditRequestTimeDialogTitle }}</span>
														<v-spacer></v-spacer>
													</v-row>
													<v-btn icon color="white" @click="closeRequestTimeDialog()">
														<v-icon>mdi-close</v-icon>
													</v-btn>
												</v-card-title>

												<v-card-text class="text-center justify-center">
													<v-container class="card-rounded pb-2 text-center justify-center">
														<v-form>
															<div>
																<v-row>
																	<v-col>
																		<v-dialog v-model="startTimeModal" :return-value.sync="startTime" persistent width="290px">
																			<template #activator="{ on }">
																				<span class="font-weight-bold">Start Time:</span>
																				<v-text-field
																					v-model="startTimeEdit"
																					placeholder="Start Time:"
																					readonly
																					filled
																					dense
																					v-on="on"
																				></v-text-field>
																			</template>
																			<v-time-picker
																				v-if="startTimeModal"
																				v-model="startTimeChange"
																				full-width
																				format="24hr"
																				:allowed-minutes="[0, 15, 30, 45]"
																			>
																				<v-spacer></v-spacer>
																				<v-btn text color="primary" @click="startTimeModal = false">Cancel</v-btn>
																				<v-btn text color="primary" @click="updateStartTimeEdit()">OK</v-btn>
																			</v-time-picker>
																		</v-dialog>
																	</v-col>
																</v-row>
																<v-row>
																	<v-col>
																		<v-dialog v-model="endTimeModal" :return-value.sync="endTime" persistent width="290px">
																			<template #activator="{ on }">
																				<span class="font-weight-bold">End Time:</span>
																				<v-text-field
																					v-model="endTimeEdit"
																					placeholder="End Time:"
																					readonly
																					filled
																					dense
																					v-on="on"
																				></v-text-field>
																			</template>
																			<v-time-picker
																				v-if="endTimeModal"
																				v-model="endTimeChange"
																				full-width
																				format="24hr"
																				:allowed-minutes="[0, 15, 30, 45]"
																			>
																				<v-spacer></v-spacer>
																				<v-btn text color="primary" @click="endTimeModal = false">Cancel</v-btn>
																				<v-btn text color="primary" @click="updateEndTimeEdit()">OK</v-btn>
																			</v-time-picker>
																		</v-dialog>
																	</v-col>
																</v-row>
															</div>
														</v-form>
													</v-container>
												</v-card-text>
												<v-card-actions>
													<v-row class="pb-1">
														<v-spacer />
														<v-col>
															<v-btn block :class="[contrastOnPrimary, 'mt-1']" :height="30" color="primary" @click="saveTimesForDate()"
																><span style="font-size: 10px">Save</span></v-btn
															>
														</v-col>
													</v-row>
												</v-card-actions>
											</v-card>
										</v-dialog>
									</v-col>
								</v-row>

								<p class="font-weight-bold black--text mb-0 mt-0">Budget</p>
								<v-row>
									<v-col>
										<span class="font-weight-bold">From:</span>
										<v-text-field
											v-model="budgetFrom"
											:rules="[rules.budgetFrom]"
											prefix="R"
											filled
											dense
											min="0"
											step="50"
											suffix="p/h"
											type="number"
										></v-text-field>
									</v-col>
									<v-col>
										<span class="font-weight-bold">To:</span>
										<v-text-field
											v-model="budgetTo"
											:rules="[rules.budgetTo]"
											prefix="R"
											suffix="p/h"
											type="number"
											:min="budgetFrom"
											step="50"
											filled
											dense
											hide-details
											single-line
										></v-text-field>
									</v-col>
								</v-row>

								<div v-if="showLunchOptions">
									<p class="font-weight-bold black--text mb-0 mt-0">Lunch</p>
									<v-row mt-0>
										<v-col class="text-center justify-center">
											<v-spacer />
											<v-btn-toggle v-model="lunchValue" block dense rounded color="secondary" class="white--text" mandatory>
												<v-btn value="paid"> Paid </v-btn>
												<v-btn style="display: none" value="default"></v-btn>
												<v-btn value="unpaid" :disabled="lunchDuration === '0.5'"> Unpaid </v-btn>
											</v-btn-toggle>
											<v-spacer />
										</v-col>
									</v-row>

									<v-row v-if="lunchValue !== 'default'" no-gutters class="mt-3 mb-2">
										<v-col class="text-center justify-center">
											<v-spacer />
											<v-btn-toggle v-model="lunchDuration" mandatory depressed block rounded dense color="secondary" :class="contrastOnSecondary">
												<v-btn value="0.5" :disabled="lunchValue === 'unpaid'"> 30 min </v-btn>

												<v-btn value="1"> 1 hour </v-btn>
											</v-btn-toggle>
											<v-spacer />
										</v-col>
									</v-row>
								</div>

								<v-row no-gutters>
									<v-col>
										<v-textarea v-model="notes" label="Notes" background-color="#F4F4F4" rounded outlined no-resize></v-textarea>
									</v-col>
								</v-row>
							</div>
						</v-form>
					</v-container>
				</v-card-text>
				<v-card-actions>
					<v-row class="pb-1">
						<v-spacer />
						<v-col :cols="3" align="center" justify="center">
							<v-btn block :class="[contrastOnPrimary, 'mt-1']" :height="30" color="primary" @click="saveOffer()"
								><span style="font-size: 10px">Save Offer</span></v-btn
							>
						</v-col>
					</v-row>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="showWarning" persistent :max-width="$vuetify.breakpoint.mobile ? '75%' : '50%'">
			<v-card class="justify-center text-center card-rounded pb-5" min-height="20vh" style="overflow-x: hidden">
				<v-card-title
					class="pa-2 white--text justify-center text-center secondary"
					style="font-family: Montserrat; font-style: normal; font-weight: bold; font-size: 12px; line-height: 7px; text-align: center"
				>
					<v-row>
						<v-spacer></v-spacer>
						<span class="headline white--text">Please Note</span>
						<v-spacer></v-spacer>
					</v-row>
				</v-card-title>

				<v-card-text>
					<v-container>
						<v-form>
							<v-row>
								<v-col class="justify-center text-center">
									Proffesionals have already applied to this Public Offer. If you edit this offer, all the applications linked to this offer will be removed. The
									professionals that has already applied to this offer will be notified that they need to reapply to this updated offer.
								</v-col>
							</v-row>
						</v-form>
					</v-container>
				</v-card-text>
				<v-card-actions>
					<v-row class="pb-1">
						<v-spacer />
						<v-col :cols="3" align="center" justify="center">
							<v-btn block :class="[contrastOnPrimary, 'mt-1']" :height="30" color="primary" @click="showWarning = false"
								><span style="font-size: 10px">Discard Edit</span></v-btn
							>
						</v-col>
						<v-col :cols="3" align="center" justify="center">
							<v-btn
								block
								class="white--text mt-1"
								:height="30"
								color="secondary"
								@click="
									showWarning = false;
									openEditWindow();
								"
								><span style="font-size: 10px">Continue Edit</span></v-btn
							>
						</v-col>
					</v-row>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import { bus } from '@/main';
import store from '@/store';
import moment from 'moment';
import CalendarDateIcon from '@/components/custom/CalendarDateIcon.vue';
import { getDefaultShiftTimes } from '@/utils/util';

export default {
	name: 'PracticeEditBookingDialog',
	components: { CalendarDateIcon },
	props: {
		booking: {},
	},
	data: () => ({
		notes: '',
		showDialog: false,
		dialogKey: 0,
		user: store.getters.user,
		company: store.getters.company,
		calendarInputMode: 0,
		lunchDuration: null,
		lunchValue: 'default',
		form: false,
		range: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
		calendarpickerdate: [],
		budgetFrom: null,
		budgetTo: null,
		startDateModal: false,
		endDateModal: false,
		selectedDatesSorted: [],
		startTime: '09:00',
		endTime: '17:00',
		startDate: null,
		endDate: null,
		minDate: new Date().toISOString().substr(0, 10),
		originalOffer: {},
		startTimeModal: false,
		endTimeModal: false,
		showWarning: false,
		apiRequest: false,

		rules: {
			startDate: v => !!v || 'Start date required',
			endDate: v => !!v || 'End date required',
			budgetFrom: v => !!v || 'Required',
			budgetTo: v => !!v || 'Required',
			experience: [v => Boolean(Object.keys(v || {})[0]) || 'Years Experience is required'],
		},
		showEditRequestTimeDialog: false,
		EditRequestTimeDialogTitle: '',
		startTimeEdit: '',
		endTimeEdit: '',
		startTimeChange: '', //variable for dialog to keep separate to not update time incase of cancel
		endTimeChange: '', //variable for dialog to keep separate to not update time incase of cancel
		request_dates: [],
		firstLoad: true,
	}),
	computed: {
		selectedDates: {
			get: function () {
				return this.selectedDatesSorted;
			},
			set: function (newValue) {
				this.selectedDatesSorted = newValue.sort((a, b) => moment(a).diff(b, 'days'));
			},
		},

		lunchPeriod() {
			if (!this.hasLunchBreak) {
				return 0;
			}
			return this.lunchDuration == 1 ? 1 : 0.5;
		},
		hasLunchBreak() {
			return this.showLunchOptions && this.lunchValue !== 'default';
		},
		hasPaidLunch() {
			return this.hasLunchBreak && this.lunchValue === 'paid';
		},

		lengthOfDay() {
			return this.formatTime(this.endTime).diff(this.formatTime(this.startTime), 'hours');
		},

		showLunchOptions() {
			return this.lengthOfDay > 5;
		},

		computedStartDateFormatted() {
			return this.startDate ? moment(this.startDate).format('dddd, MMMM Do YYYY') : '';
		},

		computedEndDateFormatted() {
			return this.endDate ? moment(this.endDate).format('dddd, MMMM Do YYYY') : '';
		},
	},
	watch: {
		selectedDatesSorted() {
			if (!this.firstLoad) {
				this.startDate = this.selectedDatesSorted[0];
				this.endDate = this.selectedDatesSorted[this.selectedDatesSorted.length - 1];
				this.calculateRequestDates();
			}
			this.firstLoad = false;
		},
	},
	created() {
		const { start, end } = getDefaultShiftTimes(this.tenant);
		this.startTime = start;
		this.endTime = end;
	},

	methods: {
		...mapActions('offers', ['ReadPublicOffer', 'UpdatePublicOffer']),
		async open() {
			this.firstLoad = true;
			this.originalOffer = await this.ReadPublicOffer(this.booking.id);
			this.request_dates = this.booking.request_dates;
			if (this.originalOffer.data.Items[0]?.offer_type === 'public' && this.originalOffer.data.Items[0].offers_requests?.length > 0) {
				this.showWarning = true;
			} else if (this.originalOffer.data.Items[0]?.offer_type === 'private') {
				this.openEditWindow();
			} else if (this.originalOffer.data.Items[0]?.offer_type === 'public' && !this.originalOffer.data.Items[0].offers_requests) {
				this.openEditWindow();
			}
		},

		openEditWindow() {
			this.showDialog = true;
			this.dialogKey += 1;
			this.initData();
		},

		close() {
			this.selectedDates = [];
			this.selectedDatesSorted = [];
			this.showDialog = false;
		},

		formatTime(val) {
			return moment(moment().format('YYYY-MM-DD ') + val);
		},
		allowedEndDates(val) {
			return this.startDate ? moment(val).isSameOrAfter(moment(this.startDate)) : true;
		},
		allowedStartDates(val) {
			return this.endDate ? moment(val).isSameOrBefore(moment(this.endDate)) : true;
		},

		allowedDatesAll(val) {
			return this.allowedEndDates(val) && this.allowedStartDates(val);
		},

		toggleLunch() {
			this.hasLunchBreak = !this.hasLunchBreak;
		},

		toggleLunch30() {
			this.hashourlunch = false;
			this.hashalfhourlunch = !this.hashalfhourlunch;
		},

		toggleLunch60() {
			this.hashalfhourlunch = false;
			this.hashourlunch = !this.hashourlunch;
		},

		calculateRequestDates(inputmode = null) {
			if (this.startDate === null && this.endDate === null) return;
			if (inputmode !== null) {
				switch (inputmode) {
					case 0:
						this.calendarInputMode = 0;
						break;
					case 1:
						this.calendarInputMode = 1;
						break;

					default:
						break;
				}
			}
			this.request_dates = [];
			if (this.calendarInputMode == 1) {
				for (let index = 0; index < this.selectedDatesSorted.length; index++) {
					let date = moment(this.selectedDatesSorted[index]).format('YYYY-MM-DD');
					this.request_dates.push({
						date: date,
						end_time: moment(`${date} ${this.endTime}`).format(),
						start_time: moment(`${date} ${this.startTime}`).format(),
					});
				}
			} else {
				let startDay = this.startDate; //this.selectedDatesSorted[0];
				let endDay = this.endDate; //this.selectedDatesSorted[this.selectedDatesSorted.length - 1];
				const countDays = startDay === endDay ? 0 : moment(endDay).startOf('day').diff(moment(startDay).endOf('day'), 'days') + 1;

				for (let day_index = 0; day_index <= countDays; day_index++) {
					let day = moment(startDay).add(day_index, 'days').format('YYYY-MM-DD');
					this.request_dates.push({
						date: day,
						end_time: moment(`${day} ${this.endTime}`).format(),
						start_time: moment(`${day} ${this.startTime}`).format(),
					});
				}
			}
			return this.request_dates;
		},

		getLocumDayTime(day, time) {
			if (this.request_dates) {
				const request_date = this.request_dates.find(({ date }) => date === day)[time];
				return moment(request_date).format('HH:mm');
			}

			return '';
		},

		onClickDateIcon(date) {
			this.EditRequestTimeDialogTitle = date.date;
			this.startTimeEdit = moment(date.start_time).format('HH:mm');
			this.endTimeEdit = moment(date.end_time).format('HH:mm');
			this.startTimeChange = this.startTimeEdit;
			this.endTimeChange = this.endTimeEdit;
			this.showEditRequestTimeDialog = true;
		},

		closeRequestTimeDialog() {
			this.showEditRequestTimeDialog = false;
		},

		updateStartTimeEdit() {
			this.startTimeEdit = this.startTimeChange;
			this.startTimeModal = false;
		},

		updateEndTimeEdit() {
			this.endTimeEdit = this.endTimeChange;
			this.endTimeModal = false;
		},

		saveTimesForDate() {
			let newDateTime = {
				date: this.EditRequestTimeDialogTitle,
				end_time: moment(`${this.EditRequestTimeDialogTitle} ${this.endTimeEdit}`).format(),
				start_time: moment(`${this.EditRequestTimeDialogTitle} ${this.startTimeEdit}`).format(),
			};
			var index = this.request_dates.findIndex(date => date.date == this.EditRequestTimeDialogTitle);
			this.request_dates[index] = newDateTime;
			this.showEditRequestTimeDialog = false;
		},

		updateRequestDateTimes(startTime, endTime) {
			if (startTime !== '') {
				for (let index = 0; index < this.request_dates.length; index++) {
					this.request_dates[index].start_time = moment(`${this.request_dates[index].date} ${startTime}`).format();
				}
				//fix dropdown
			} else if (endTime !== '') {
				for (let index = 0; index < this.request_dates.length; index++) {
					this.request_dates[index].end_time = moment(`${this.request_dates[index].date} ${endTime}`).format();
				}
				//fix dropdown
			}
		},

		initData() {
			this.startDate = this.booking.request_dates[0].date;
			this.endDate = this.booking.request_dates[this.booking.request_dates.length - 1].date;
			this.startTime = this.booking.start_time;
			this.endTime = this.booking.end_time;
			this.budgetFrom = this.booking.rates[0];
			this.budgetTo = this.booking.rates[this.booking.rates.length - 1];
			this.lunchValue = this.booking.lunch.paid ? 'paid' : 'unpaid';
			this.lunchDuration = this.booking.lunch.period;
			this.booking.request_dates.forEach(request_date => {
				this.selectedDates.push(request_date.date);
			});
			this.notes = this.booking.notes;
		},

		async saveOffer() {
			if (this.calendarInputMode === 0) {
				this.selectedDates = [];
				for (var m = moment(this.startDate); m.diff(this.endDate, 'days') <= 0; m.add(1, 'days')) {
					this.selectedDates.push(m.format('YYYY-MM-DD'));
				}
			}
			let lunch = {
				allowed: this.lunchDuration === 0 ? false : true,
				period: this.lunchDuration,
				paid: this.lunchValue === 'unpaid' ? false : true,
			};

			let rates = [this.budgetFrom, this.budgetTo];
			let offer = {
				id: this.booking.id,
				date: this.startDate,
				end_date: this.endDate,
				start_time: moment(this.request_dates[0].start_time).format('HH:mm'),
				end_time: moment(this.request_dates[this.request_dates.length - 1].end_time).format('HH:mm'),
				// start_time: this.startTime,
				// end_time: this.endTime,
				available_dates: this.selectedDates,
				lunch: lunch,
				rates: rates,
				request_dates: this.request_dates,
				notes: this.notes,
				skills: this.originalOffer.data.Items[0].skills,
				company: this.originalOffer.data.Items[0].company,
				offer_code: this.originalOffer.data.Items[0].offer_code,
				offers_requests: this.originalOffer.data.Items[0].offers_requests,
				offer_type: this.originalOffer.data.Items[0]?.offer_type,
			};
			this.UpdatePublicOffer(offer);
			this.$emit('bookigUpdate', offer);
			bus.$emit('UpdateCalendar');
			this.request_dates = [];
			this.close();
		},
	},
};
</script>
